// Import model
import { StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest } from '../models/StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest - handles JSON serialization and deserialization with type validation
 */
export class StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequestSerializer {
  /**
   * Deserializes a JSON string into a StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static deserialize(json: string): StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance
   */
  static fromObject(obj: any): StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest');
    }


    const instance: StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest = {
      phoneNumber: obj['PhoneNumber'] as string | undefined,
      description: obj['Description'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instances
   */
  static deserializeArray(json: string): StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a JSON string
   */
  static serialize(instance: StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instance to a plain object
   */
  static toObject(instance: StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest): any {
    return {
      'PhoneNumber': instance.phoneNumber,
      'Description': instance.description,
    };
  }

  /**
   * Serializes an array of StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest instances to a JSON string
   */
  static serializeArray(instances: StartObjectAppointmentInitiateSmsForUpcomingApppointmentRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
